(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mip-mixed-name"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mip-mixed-name')) {
    customElements.define('mip-mixed-name', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        this.update = () => {
          const choices = Array.from(this.scope.querySelectorAll('variant-picker input:checked, variant-picker select'));
          const selected = choices.find(el => /^(Add names|Without names)$/.test(el.value));
          const needed = selected ? selected.value === 'Add names' : this.dataset.initial === 'true';
          const input = this.querySelector('textarea');
          this.querySelector('[data-name-fields]').hidden = !needed;
          input.disabled = !needed;
          input.required = needed;
        };
        this.scope.addEventListener('change', this.update);
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.scope, { childList:true, subtree:true });
        this.update();
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.update);
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
